import styled, { css } from "styled-components";

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: var(--fd-space-space-1);
`;

export const HeaderContainer = styled.div<{ isMobile: boolean }>`
  padding: var(--fd-space-space-4);
  background: var(--fd-colors-background-surface);
  border-radius: ${({ isMobile }) =>
    isMobile
      ? "0"
      : "var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020) 0 0"};
`;

export const Section = styled.div<{
  isFromHomePage: boolean;
  isMobile: boolean;
}>`
  background: var(--fd-colors-background-base);
  ${({ isFromHomePage }) =>
    isFromHomePage &&
    css`
      padding: var(--fd-space-space-4) var(--fd-space-space-4)
        var(--fd-space-space-4) 0;
    `};
  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: var(--fd-space-space-4) 0;
    `};
`;
